
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import RadioOption from "@/entities/RadioOption";

  @Component
  export default class RadioButtonGroup extends Vue {
    @Prop({ default: "all", type: String }) value!: string;
    @Prop({ required: true, type: Array }) options!: RadioOption[];
    @Prop({ default: "radioChoice", type: String }) name!: string;

    @Prop({ type: String, default: '' }) readonly parentClass!: string;
    @Prop({ type: String, default: '' }) readonly labelClasses!: string;
    @Prop({ type: String, default: 'radio' }) readonly type!: string;
    @Prop({ type: String, default: '#07f' }) readonly color!: string;
    @Prop({ type: String, default: 'grey' }) readonly bColor!: string;

get isCheckBox(){
return this.type === 'checkbox'
}



    handleChange(event: any) {
      this.$emit("input", event.target.value);
    }
  }
